// Sidebar.js
import { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css'; // Importing CSS for Sidebar
import { useUser } from '@clerk/clerk-react';
import { useRevit } from '../../contexts/RevitContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import Icon from '../Icon';

const Sidebar = ({ isOpen, toggleSidebar, isProAccount, isFounder, setShowUserProfile, isOnboardingCompleted, setIsOnboardingCompleted }) => {
    const { isSecondaryUser, isSubAccountActive } = useRevit();
    const { user } = useUser();

    const location = useLocation();
    const isCollapsed = location.pathname === '/code';

    // Close sidebar on route change
    useEffect(() => {
        if (isOpen && window.innerWidth <= 1024) {
            toggleSidebar();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    // Toggle body class so FunnelMapper CSS can adjust its margin
    useEffect(() => {
        if (isCollapsed) {
            document.body.classList.add('sidebar-is-collapsed');
        } else {
            document.body.classList.remove('sidebar-is-collapsed');
        }
        return () => document.body.classList.remove('sidebar-is-collapsed');
    }, [isCollapsed]);

    const toggleUserMenu = () => {
        setShowUserProfile(prev => !prev);
    };

    return (
        <>
            <button className="mobile-nav-toggle" onClick={toggleSidebar}>
                <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
            </button>
            
            <div 
                className={`sidebar-overlay ${isOpen ? 'show' : ''}`} 
                onClick={toggleSidebar}
            />
            
            <div className={`sidebar ${isOpen ? 'open' : ''}${isCollapsed ? ' sidebar--collapsed' : ''}`}>
                <h2 className='heading-h4 sidebar-title'>Revtrack</h2>
                <ul>
                    {/* {!isOnboardingCompleted && (
                        <>
                            <li>
                                <NavLink to="/getting-started" className='body-medium-medium' activeClassName="active">
                                    {({ isActive }) => (
                                        <>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Icon name="help" size={20} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                                Getting Started
                                            </div>
                                            {isActive && <Icon name="arrow" size={20} color="var(--Text-Body1)" />}
                                        </>
                                    )}
                                </NavLink>
                            </li>
                            <li className="sidebar-divider"></li>
                        </>
                    )} */}
                    <li>
                        <NavLink to="/overview" className='body-medium-medium' activeClassName="active" title={isCollapsed ? 'Overview' : undefined}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "dashboardFill" : "dashboard"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Overview</span>
                                    </div>
                                    {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/analytics" activeClassName="active" title={isCollapsed ? 'Analytics' : undefined}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "analyticsFill" : "analytics"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Analytics</span>
                                    </div>
                                    {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/audience" activeClassName="active" title={isCollapsed ? 'Audience' : undefined}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "audienceFill" : "audience"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Audience</span>
                                    </div>
                                    {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/content" activeClassName="active" title={isCollapsed ? 'Content' : undefined}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "contentFill" : "content"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Content</span>
                                    </div>
                                    {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/links" activeClassName="active" title={isCollapsed ? 'Links' : undefined}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={"click"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Links</span>
                                    </div>
                                    {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/code" activeClassName="active" title={isCollapsed ? 'Offers' : undefined}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "codeFill" : "code"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Offers</span>
                                    </div>
                                    {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/activity" activeClassName="active" title={isCollapsed ? 'Conversion activity' : undefined}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "activityFill" : "activity"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Conversion Activity</span>
                                    </div>
                                    {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={(isProAccount || isFounder) ? "/split-tests" : "#"} 
                                className={({ isActive }) => 
                                    `${!(isProAccount || isFounder) ? "disabled-link" : ""} ${isActive && (isProAccount || isFounder) ? "active" : ""}`
                                } 
                                onClick={e => !(isProAccount || isFounder) && e.preventDefault()}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Icon name="splitTest" size={16} color={isActive && (isProAccount || isFounder) ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                            <span className="sidebar-label">Split Tests</span>
                                        </div>
                                        {!(isProAccount || isFounder) && <span className="pro-badge">PRO</span>}
                                    </div>
                                    {isActive && (isProAccount || isFounder) && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={(isProAccount || isFounder) ? "/ideas" : "#"} 
                                className={({ isActive }) => 
                                    `${!(isProAccount || isFounder) ? "disabled-link" : ""} ${isActive && (isProAccount || isFounder) ? "active" : ""}`
                                } 
                                onClick={e => !(isProAccount || isFounder) && e.preventDefault()}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Icon name={isActive && (isProAccount || isFounder) ? "ideasFill" : "ideas"} size={16} color={isActive && (isProAccount || isFounder) ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                            <span className="sidebar-label">AI Insights</span>
                                        </div>
                                        {!(isProAccount || isFounder) && <span className="pro-badge">PRO</span>}
                                    </div>
                                    {isActive && (isProAccount || isFounder) && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                   <li>
                        <NavLink to={(isProAccount || isFounder) ? "/redirect-links" : "#"} 
                                className={({ isActive }) => 
                                    `${!(isProAccount || isFounder) ? "disabled-link" : ""} ${isActive && (isProAccount || isFounder) ? "active" : ""}`
                                } 
                                onClick={e => !(isProAccount || isFounder) && e.preventDefault()}>
                            {({ isActive }) => (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                             <Icon name="click" size={16} color={isActive && (isProAccount || isFounder) ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                             <span className="sidebar-label">Urgency Links</span>
                                        </div>
                                        {!(isProAccount || isFounder) && <span className="pro-badge">PRO</span>}
                                    </div>
                                    {isActive && (isProAccount || isFounder) && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                </>
                            )}
                        </NavLink>
                    </li>
                </ul>
                <div className="bottom-section">
                    <ul className="bottom-menu">
                        {/* <li>
                        <NavLink to="/integrations" activeClassName="active" title={isCollapsed ? 'Integrations' : undefined}>
                                {({ isActive }) => (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "integrationsFill" : "integrations"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Integrations</span>
                                        </div>
                                        {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                    </>
                                )}
                            </NavLink>
                        </li> */}
                        <li>
                        <NavLink to="/help" activeClassName="active" title={isCollapsed ? 'Troubleshooting' : undefined}>
                                {({ isActive }) => (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Icon name={isActive ? "helpFill" : "help"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                        <span className="sidebar-label">Troubleshooting</span>
                                        </div>
                                        {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                    </>
                                )}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to={(isProAccount || isFounder) ? "/api-keys" : "#"} 
                                className={({ isActive }) => 
                                    `${!(isProAccount || isFounder) ? "disabled-link" : ""} ${isActive && (isProAccount || isFounder) ? "active" : ""}`
                                }
                                onClick={e => !(isProAccount || isFounder) && e.preventDefault()}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Icon name={isActive && (isProAccount || isFounder) ? "settingsFill" : "settings"} size={16} color={isActive && (isProAccount || isFounder) ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                                <span className="sidebar-label">API & MCP Server</span>
                                            </div>
                                            {!(isProAccount || isFounder) && <span className="pro-badge">PRO</span>}
                                        </div>
                                        {isActive && (isProAccount || isFounder) && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                    </>
                                )}
                            </NavLink>
                        </li>
                        {!isSecondaryUser && !isSubAccountActive && (
                            <li>
                                <NavLink to="/account-management" activeClassName="active">
                                    {({ isActive }) => (
                                        <>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Icon name={isActive ? "settingsFill" : "settings"} size={16} color={isActive ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                                <span className="sidebar-label">Sub Accounts</span>
                                            </div>
                                            {isActive && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                        </>
                                    )}
                                </NavLink>
                            </li>
                        )}
                        {!isSecondaryUser && !isSubAccountActive && (
                            <li>
                                <NavLink 
                                    to={isProAccount ? "/team-management" : "#"} 
                                    className={({ isActive }) => 
                                        `${!isProAccount ? "disabled-link" : ""} ${isActive && isProAccount ? "active" : ""}`
                                    }
                                    onClick={e => !isProAccount && e.preventDefault()}
                                >
                                    {({ isActive }) => (
                                        <>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Icon name={isActive && isProAccount ? "teamFill" : "team"} size={16} color={isActive && isProAccount ? 'var(--Primary-500)' : 'var(--Text-Body1)'} />
                                                <span className="sidebar-label">Team</span>
                                                {!isProAccount && <span className="pro-badge">PRO</span>}
                                            </div>
                                            {isActive && isProAccount && <Icon name="arrow" size={16} color="var(--Text-Body1)" className="sidebar-arrow" />}
                                        </>
                                    )}
                                </NavLink>
                            </li>
                        )}
                    </ul>
                    <div className="user-section">
                    <div className="custom-user-button" onClick={toggleUserMenu} title={isCollapsed ? (user?.primaryEmailAddress?.emailAddress || 'Account') : undefined}>
                            <img 
                                src={user?.imageUrl} 
                                alt="User avatar" 
                                className="user-avatar"
                            />
                            <div className="sidebar-label"><span className="user-account-email">{user?.primaryEmailAddress?.emailAddress}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
